"use client";

import React from "react";
import Header from "../global/partials/Header";
import Footer from "../global/partials/Footer";
import { PageReviewsSchema } from "@/sanity/pages/PageReviewsTemplate";
import HeroSection from "../pageComponents/reviews/HeroSection";
import ReviewsGridSection from "../pageComponents/reviews/ReviewsGridSection";
import HeaderV2 from "../global/partials/HeaderV2";

export default function PageReviewsJSX({ data }: { data: PageReviewsSchema }) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType={"main"} // showBorder
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />
      <ReviewsGridSection data={data} language={data.settings?.language} />

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
